import {useEffect, useRef} from "preact/compat";

const MAX_CIRCLE_RADIUS = 176;

export const useCircularProgressBar = (props) => {
    // Destructured props
    const {
        currentStep,
        maxSteps
    } = props;

    //Ref for the green circle element
    const circleRef = useRef(null);

    // Effect to update the progress bar status
    useEffect(() => {
        // Calculates the current percentage
        const calc = Math.round((currentStep / maxSteps) * MAX_CIRCLE_RADIUS);

        // Updates the element style
        circleRef.current.style.strokeDashoffset = calc < 1 ? MAX_CIRCLE_RADIUS - 1 : MAX_CIRCLE_RADIUS - calc;
    }, [
        currentStep,
        maxSteps
    ]);

    return {
        circleRef,
    }
}
